// @flow

import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {Grid, makeStyles, Typography} from '@material-ui/core';
import CustomModal from '../../../../../elements/CustomModal/CustomModal';
import {colors} from '../../../../../assets/styles/colors';
import CustomButton from '../../../../../elements/CustomButton/CustomButton';
import {MuiPickersUtilsProvider} from '@material-ui/pickers';
import CustomTextField from '../../../../../elements/CustomTextField/CustomTextField';
//$FlowFixMe
import dayJsUtils from '@date-io/dayjs';
import type {Theme} from '@material-ui/core';
import CustomDatePicker from '../../../../marketing/coupons/components/CustomDatePicker/CustomDatePicker';

type Props = {
  open: boolean,
  handleClose: () => void,
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    marginTop: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: 700,
    maxWidth: '100%',
  },
  title: {
    fontSize: 18,
    color: colors.grey900,
    fontWeight: 600,
  },
  content: {
    width: '100%',
    margin: theme.spacing(1.5, 0),
  },
  step: {
    color: colors.grey900,
    fontSize: 14,
    fontWeight: 500,
  },
  innerContent: {
    marginTop: theme.spacing(2),
  },
  datePickerWrap: {
    boxShadow:
      '0px 2px 8px rgba(40, 41, 61, 0.04), 0px 16px 24px rgba(96, 97, 112, 0.16)',
    borderRadius: 16,
    overflow: 'hidden',
  },
  button: {
    fontSize: 16,
    fontWeight: 600,
  },
}));

export default function NewTaskModal(props: Props) {
  const {open, handleClose} = props;
  const classes = useStyles();

  const [dateSelected, setDateSelected] = useState(new Date());

  return (
    <CustomModal open={open} handleCloseModal={handleClose}>
      <div className={classes.root}>
        <Typography className={classes.title}>Nueva tarea</Typography>
        <div className={classes.content}>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <Typography className={classes.step}>
                1. Selecciona la fecha
              </Typography>
              <div className={classes.innerContent}>
                <div className={classes.datePickerWrap}>
                  <MuiPickersUtilsProvider utils={dayJsUtils}>
                    <CustomDatePicker
                      variant="static"
                      handleChange={setDateSelected}
                      value={dateSelected}
                      minDate={new Date()}
                    />
                  </MuiPickersUtilsProvider>
                </div>
              </div>
            </Grid>
            <Grid
              item
              xs={6}
              direction="column"
              justify="space-between"
              style={{display: 'flex'}}
            >
              <div>
                <Typography className={classes.step}>
                  2. Describe la tarea y asígnala al colaborador
                </Typography>

                <div className={classes.innerContent}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <CustomTextField
                        name="taskName"
                        label="Descripción de la tarea"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <CustomTextField
                        name="taskName"
                        label="Descripción de la tarea"
                      />
                    </Grid>
                  </Grid>
                </div>
              </div>

              <CustomButton
                fullWidth
                className={classes.button}
                variant="contained"
              >
                Crear nueva tarea
              </CustomButton>
            </Grid>
          </Grid>
        </div>
      </div>
    </CustomModal>
  );
}

NewTaskModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};
